module.exports = __webpack_public_path__ + "files/a449a4a46e91c6ebfd02de1ba8b9c9a7.svg";